export default "__VITE_ASSET__D05u7Spb__"